// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false
		// paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
		// 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
	},
    selector: {
		trackingQuickView: '.quick_shop',
        trackingAddToCart: 'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] .button--add-to-cart',
	}
};
var boostPFSAppConfig = {
  selector: {
	trackingProduct: '.boost-pfs-filter-products > *',
	trackingQuickView: '.boost-pfs-quickview-btn',
	trackingAddToCart: 'form[action="/cart/add"] *[type="submit"]',
	trackingBuyNow: '.shopify-payment-button, #dynamic-checkout-cart',
  },
  general: {
    current_locale: boostPFSConfig.general.current_locale
  }
}
// Declare Templates
var boostPFSTemplate = {
	// Grid Template
    'productGridItemHtml': '<div class="{{itemDesktopWidthClass}} medium-down--one-third small-down--one-half {{itemMobileWidthClass}} column {{itemQuickShopClass}} {{itemSwapImageClass}} {{itemHoverImage}} {{itemStickersClass}}' +
      ' thumbnail product__thumbnail product__grid-item' +
      ' thumbnail__hover-overlay--{{itemHoverClass}}' +
      ' has-padding-bottom">' +
      '<div class="product-wrap">' +
        '<div class="product-image__wrapper">' +
          '<div class="image__container product__imageContainer">' +
            '<a class="product-link" href="{{itemUrl}}">' +
              '{{itemStickers}}' +
              '{{itemImages}}' +
            '</a>' +
            '{{itemHover}}' +
          '</div>' +
        '</div>' +
        '<div class="quickview-container">' +
          '<div class="mobile-quickview-sizes">' + '</div>' +
          '<button class="mobile-quickview-btn" data-product-selected="">Quick Shop' + '</button>' +
        '</div>' +
        '<div class="thumbnail__caption text-align-{{itemTextAlignClass}}">' +
          '{{itemProductInfo}}' +
        '</div>' +
      '</div>' +
      '{{itemMessaging}}' +
      '{{itemSwatch}}' +
      '{{itemReviews}}' +
    '</div>'+
    '{{inlineCard}}',

	'itemHoverHtml' : '<div class="thumbnail-overlay__container">' +
							'{{itemQuickShop}}' +
						    '{{itemReviewsHover}}' +
						'</div>',

	'itemProductInfoHtml': '<div class="product-thumbnail">' +
								'{{itemVendor}}' +
								'<a href="{{itemUrl}}" class="product-link product-thumbnail__title">{{itemTitle}}</a>' +
                                '{{itemWishlist}}' +
								'{{itemComingSoon}}' +
								'{{itemPrice}}' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<a href="{{itemUrl}}" class="pagination-previous">'+ boostPFSConfig.label.previous +'</a>',
	'nextActiveHtml': '<a href="{{itemUrl}}" class="pagination-next">'+ boostPFSConfig.label.next +'</a>',
	'pageItemHtml': '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li><a class="pagination-ellipsis">…</a></li>',
	'paginateHtml': '<nav class="pagination paginate--both" role="navigation" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
    'inlineCard': '<div class="testerino medium-down--one-third small-down--one-half column>' +
                    '</div > ',
};

(function () {
	BoostPFS.inject(this);

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
      if (!data) data = this.data;
      if (!index) index = this.index;
      if (!totalProduct) totalProduct = this.totalProduct;

      // Get Template
      var itemHtml = boostPFSTemplate.productGridItemHtml;

      var currentPage = parseInt(Globals.queryParams.page);
      let collectionCTAIndex = 'false';
      let collectionCTAIndex2 = 'false';
      let ctaPath = null;

      if (currentPage == 1) ctaPath = window.eHS.ctasPage1
      else if (currentPage == 2) ctaPath = window.eHS.ctasPage2

      if (ctaPath != null && ctaPath.collectionCTA_1.collection != null) {
        for (let index = 0; index < ctaPath.collectionCTA_1.collection.length; index++) {
          const collection = ctaPath.collectionCTA_1.collection[index];
          const collectionList = ctaPath.collectionCTA_1.collection[index].split('|');

          if (collectionList.includes(window.eHS.currentCollection) && ctaPath.collectionCTA_1.background != null) {
            collectionCTAIndex = ctaPath.collectionCTA_1.collection.indexOf(collection)
            break;
          }
        }
      }

      if (ctaPath != null && ctaPath.collectionCTA_2.collection != null) {
        for (let index = 0; index < ctaPath.collectionCTA_2.collection.length; index++) {
          const collection = ctaPath.collectionCTA_2.collection[index];

          if (collection.includes(window.eHS.currentCollection) && ctaPath.collectionCTA_2.background != null) {
            collectionCTAIndex2 = ctaPath.collectionCTA_2.collection.indexOf(collection)
            break;
          }
        }
      }

      let promoHtml = ''
      if (index == 11) {
        if (collectionCTAIndex >= 0 && collectionCTAIndex != 'false' && ctaPath.collectionCTA_1.background[collectionCTAIndex] != '') {
          promoHtml = '<div class="inline-cta"><a href="{{ctaLink}}"><div class="inline-cta-inner"><img class="inline-cta-bg"src="{{ctaBackground}}"/><img class="inline-cta-bg inline-cta-bg--mobile"src="{{ctaBackgroundMobile}}"/></div></a></div>'
          promoHtml = promoHtml.replace(/{{ctaBackground}}/g, ctaPath.collectionCTA_1.background[collectionCTAIndex]);
          promoHtml = promoHtml.replace(/{{ctaLink}}/g, ctaPath.collectionCTA_1.link[collectionCTAIndex]);

          if (ctaPath.collectionCTA_1.backgroundMobile[collectionCTAIndex] == '') {
            promoHtml = promoHtml.replace(/{{ctaBackgroundMobile}}/g, ctaPath.collectionCTA_1.background[collectionCTAIndex]);
          } else {
            promoHtml = promoHtml.replace(/{{ctaBackgroundMobile}}/g, ctaPath.collectionCTA_1.backgroundMobile[collectionCTAIndex]);
          }
        } else {
          promoHtml = promoHtml.replace(/{{inlineCard}}/g, '');
        }
      } else if (index == 23) {
        if (collectionCTAIndex2 >= 0 && collectionCTAIndex2 != 'false' && ctaPath.collectionCTA_2.background[collectionCTAIndex2] != '') {
          promoHtml = '<div class="inline-cta"><a href="{{ctaLink}}"><div class="inline-cta-inner"><img class="inline-cta-bg"src="{{ctaBackground}}"/><img class="inline-cta-bg inline-cta-bg--mobile"src="{{ctaBackgroundMobile}}"/></div></a></div>'
          promoHtml = promoHtml.replace(/{{ctaBackground}}/g, ctaPath.collectionCTA_2.background[collectionCTAIndex2]);
          promoHtml = promoHtml.replace(/{{ctaLink}}/g, ctaPath.collectionCTA_2.link[collectionCTAIndex2]);

          if (ctaPath.collectionCTA_2.backgroundMobile[collectionCTAIndex2] == '') {
            promoHtml = promoHtml.replace(/{{ctaBackgroundMobile}}/g, ctaPath.collectionCTA_2.background[collectionCTAIndex2]);
          } else {
            promoHtml = promoHtml.replace(/{{ctaBackgroundMobile}}/g, ctaPath.collectionCTA_2.backgroundMobile[collectionCTAIndex2]);
          }
        } else {
          promoHtml = promoHtml.replace(/{{inlineCard}}/g, '');
        }
      }

      const itemUrl = data.split_product ? `${Utils.buildProductItemUrl(data)}?variant=${data.variant_id}` : Utils.buildProductItemUrl(data)

      const newCollectionItemHtml = `
        <collection-item class="collection-item ">
          <div class="collection-item__media-wrapper">
            ${buildBadges(data)}
            ${buildWishlistButton(data)}
            <a href="${itemUrl}" tabindex="-1" class="collection-item__media-link" data-collection-item-link>
              ${buildImages(data)}
            </a>
            ${buildHoverCta(data)}
          </div>
          <div class="collection-item__meta">
            ${data.vendor ? `
              <span class="collection-item__vendor">
                ${data.vendor}
              </span>
            ` : ''}
            <a href="${itemUrl}" class="collection-item__title" data-collection-item-link>
              ${data.title}
            </a>
            ${buildPrice(data)}
          </div>
          ${buildItemSwatches(data)}
          ${buildMessaging(data)}
        </collection-item>
        ${promoHtml}
      `

      return newCollectionItemHtml;
    };

    const buildHoverCta = (data) => {
      if (!data.available || !boostPFSConfig.custom.enable_quickshop) return ''
      if (data.variants.length === 1) return `
        <div class="collection-item__hover">
          <form
            method="post"
            action="/cart/add"
            id="quick-add-${data.variants[0].id}"
            accept-charset="UTF-8"
            enctype="multipart/form-data"
          >
            <input type="hidden" name="id" value="${data.variants[0].id}">
            <input type="hidden" name="form_type" value="product">
            <button class="collection-item__hover-button" type="submit" name="add">
              <svg class="is-hidden-desktop-only" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.6709 0C7.29008 0.00013625 8.61652 1.20939 8.81055 2.76855H10.4844L10.5566 2.77539C10.7202 2.80756 10.8469 2.94596 10.8584 3.11816L11.207 8.41602C12.1364 8.95554 12.7626 9.95946 12.7627 11.1113C12.7627 12.8323 11.3675 14.2285 9.64648 14.2285C8.57564 14.2284 7.63134 13.6884 7.07031 12.8662H2.24512C1.00502 12.8662 1.33949e-05 11.8612 0 10.6211C0 10.613 0.000446865 10.6048 0.000976562 10.5967L0.493164 3.11816L0.504883 3.04688C0.547607 2.88549 0.694339 2.76855 0.867188 2.76855H2.54102C2.73498 1.20999 4.06012 0 5.6709 0ZM9.64746 9.38477C9.47239 9.38477 9.33008 9.52707 9.33008 9.70215V10.7949H8.2373C8.06232 10.7949 7.92007 10.9364 7.91992 11.1113C7.91992 11.2864 8.06223 11.4287 8.2373 11.4287H9.33008V12.5215C9.33026 12.6964 9.4725 12.8379 9.64746 12.8379C9.82197 12.8374 9.96369 12.6961 9.96387 12.5215V11.4287H11.0566C11.2313 11.4283 11.373 11.2861 11.373 11.1113C11.3729 10.9367 11.2312 10.7954 11.0566 10.7949H9.96387V9.70215C9.96387 9.5274 9.82209 9.38529 9.64746 9.38477ZM0.75 10.626C0.752644 11.4496 1.42086 12.1162 2.24512 12.1162H6.69629C6.58894 11.8009 6.53027 11.4629 6.53027 11.1113C6.53037 9.39051 7.92469 7.9943 9.64648 7.99414C9.91796 7.99414 10.1816 8.02946 10.4326 8.09473L10.1328 3.51855H8.47266C8.46946 3.51866 8.46611 3.51951 8.46289 3.51953C8.45929 3.51955 8.45573 3.51863 8.45215 3.51855H2.89844C2.89502 3.51862 2.89114 3.51955 2.8877 3.51953C2.88442 3.51951 2.88119 3.51866 2.87793 3.51855H1.21777L0.75 10.626ZM5.6709 0.75C4.47732 0.75 3.48895 1.62393 3.30078 2.76855H8.05078C7.86261 1.6246 6.87412 0.750133 5.6709 0.75Z" fill="#101B2A"/>
              </svg>

              <span class="visuallyhidden">${boostPFSConfig.label.add_to_cart}</span>
              <span class="is-hidden-mobile-only" aria-hidden="true">${boostPFSConfig.label.add_to_cart}</span>
            </button>
          </form>
        </div>
      `
      return `
        <button
          data-fancybox
          data-type="ajax"
          data-src="${Utils.buildProductItemUrl(data)}"
          data-filter="product-wrap"
          class="hidden"
        >
          Quick Shop
          <span class="visuallyhidden">
            ${data.title}
          </span>
        </button>

        <div class="collection-item__hover" data-boost-pfs-quickshop-id="${data.id}" style="display: none"></div>
      `
    }

    const buildItemSwatches = (data) => {
      if (!boostPFSConfig.custom.collection_swatches) return ''
      if (!data.options.length || !(data.options.includes('color') || data.options.includes('colour'))) return ''
      const colorIndex = data.options.findIndex(option => option === 'color' || option === 'colour') + 1
      const uniqueSwatches = data.variants.reduce((accumulator, current) => {
        if (!accumulator.find((item) => item[`option${colorIndex}`] === current[`option${colorIndex}`])) {
          accumulator.push(current)
        }
        return accumulator
      }, [])

      const swatchHtml = uniqueSwatches.map((variant, index) => {
        const color = variant[`option${colorIndex}`]
        let variantImage = '';
        if (variant.image) {
          switch (boostPFSConfig.custom.products_per_row) {
            case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
            case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
            default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
          }
        }
        const selected = data.split_product ? Boolean(data.variant_id === variant.id) : Boolean(index === 0)
        return `
              <button
                class="collection-item__swatch ${selected ? 'active' : ''}"
                data-collection-item-swatch
                data-color="${color}"
                data-variant-id="${variant.id}"
                data-url="${Utils.buildProductItemUrl(data)}?variant=${variant.id}"
                data-image-url="${variantImage}"
                data-image-srcset="${bgset({ src: variant.image, width: 2048, height: 2048 })}"
              >
                <div role="presentation" aria-hidden="true" style="background-image:url('${boostPFSConfig.general.file_url.split('?')[0] + Utils.slugify(color) + '_50x.png'}'); background-color: ${Utils.slugify(color)};"></div>
                <span class="visuallyhidden">
                  ${color}
                </span>
              </button>
            `
      })

      const moreUrl = `<a href="${Utils.buildProductItemUrl(data)}" title="View ${swatchHtml.length} colors for ${data.title}" class="collection-item__more">+${swatchHtml.length - 4} <span class="visuallyhidden">more styles</span></a>`

      return `
        <div class="collection-item__swatches">
          ${swatchHtml.slice(0, 4).join('')}
          ${swatchHtml.length > 4 ? moreUrl : ''}
        </div>
      `
    }

    const buildWishlistButton = (data) => {
      if (!data.available && data.tags.includes('no-oos')) return ''

      return `
        <button
          data-with-epi="true"
          class="collection-item__wishlist swym-button swym-add-to-wishlist-view-product product_${data.id}"
          data-swaction="addToWishlist"
          data-product-id="${JSON.stringify(data.id)}"
          data-variant-id="${data.variant_id || data.variants[0].id}"
          data-product-url="${boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false)}"
          data-collection-item-wishlist
        >
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 14" fill="none">
            <path d="M14.6032 3.90959C14.5572 3.54759 14.3762 2.27359 13.2572 1.33359C12.0222 0.296588 10.5702 0.444588 10.2302 0.488588C8.73421 0.687588 7.84421 1.91559 7.54521 2.29959C7.24621 1.91559 6.35621 0.687588 4.86121 0.488588C4.52121 0.444588 3.06821 0.296588 1.83321 1.33359C0.715213 2.27359 0.533213 3.54759 0.488213 3.90959C0.259213 5.71359 1.30321 7.01259 1.49721 7.24559C3.51321 9.21459 5.52921 11.1836 7.54521 13.1526C9.56221 11.1836 11.5782 9.21459 13.5942 7.24559C13.7882 7.01259 14.8312 5.71359 14.6032 3.90959Z" fill="white" fill-opacity="0.75" stroke="#101B2A" stroke-width="0.911" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="wishlist-label visuallyhidden">
            Add to Wishlist
          </span>
        </button>`
    }

    const buildBadges = (data) => {
      if (!boostPFSConfig.custom.stickers_enabled) { return '' }

      let stickerToShow = ''
      const defaultHex = '00c1de';
      const tags = data.tags.map(tag => tag);
      const customTag = tags.find((tag) => {
        if (!tag.includes('badge:')) { return false }
        if (
          tag.includes('badge:final-sale') ||
          tag.includes('badge:new-arrival') ||
          tag.includes('badge:best-seller') ||
          tag.includes('badge:online-exclusive')
        ) { return false }
        return true
      })
      const backupTag = tags.find(tag => tag.includes('badge:new-arrival')) ||
        tags.find(tag => tag.includes('badge:best-seller')) ||
        tags.find(tag => tag.includes('badge:online-exclusive'))

      const renderCustomSticker = () => {
        let stickerText = customTag.replace('badge:', '').replace(/-/g, ' ');
        let badgeColor = stickerText.split('_')[1] || defaultHex;

        return `
          <span class="collection-item__badge collection-item__badge--custom" ${badgeColor !== '' ? `style="--badge-color: #${badgeColor}"` : ''}>
            ${stickerText.split('_')[0].replace('pm exclusive', 'PM Exclusive')}
          </span>
        `
      }

      if (!data.available) {
        stickerToShow = '<span class="collection-item__badge collection-item__badge--oos">out of stock</span>'
      } else if (customTag) {
        stickerToShow = renderCustomSticker()
      } else if (data.available && data.price_min < data.compare_at_price_max) {
        stickerToShow = `<span class="collection-item__badge collection-item__badge--sale">${boostPFSConfig.label.sale.replace('per%', calculateSavings(data))}</span>`
      } else if (backupTag) {
        const badgeText = backupTag.replace('badge:', '').replace(/-/g, ' ').split('_')[0]
        const badgeClass = badgeText.replace(' ', '-')
        stickerToShow = `
          <span class="collection-item__badge collection-item__badge--${badgeClass.toLowerCase().replace(' ', '-')}">
              ${backupTag.replace('badge:', '').replace(/-/g, ' ').split('_')[0]}
          </span>
        `
      }

      return stickerToShow !== '' ? `
        <div class="collection-item__badges">
          ${stickerToShow}
        </div>
      ` : '';
    }

    function calculateSavings (data) {
      console.log({
        data,
        price: data.price_min,
        max: data.compare_at_price_max
      })
      const priceDiff = data.compare_at_price_max - data.price_min
      const savings = (priceDiff / data.compare_at_price_max) * 100
      // ((Compare - at Price - Sale Price) / Compare-at Price) * 100
      return `${Math.round(savings)}%`
    }

    function buildImages(data){
        var html = '';
        var images = data.images_info;
        if (!images || images.length == 0){
            images.push({
                src: boostPFSConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }

        html += buildImageElement(images[0]);

        if (images.length > 1){
            html += buildImageElement(images[1], 'collection-item__image--secondary');
        }

        return html;
    }

    function buildImageElement(image, additionalClass = '') {
      const lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';
      return `
        <img
          alt="${image.alt}"
          class="collection-item__image ${additionalClass} lazyload transition--${boostPFSConfig.custom.image_loading_style} ${additionalClass}"
          ${(lowQualityImage && lowQualityImage !== '') ? `src="${lowQualityImage}"` : ''}
          data-src="${Utils.optimizeImage(image.src, '1600x')}"
          data-sizes="auto"
          data-aspectratio="1"
          data-srcset="${bgset(image)}"
          srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          height="${image.height}"
          width="${image.width}"
          data-collection-item-image
        />
      `
    }

    function buildHover(data){
        var html = '';
        if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled){
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSConfig.custom.thumbnail_hover_enabled){
                var itemProductInfoHover = 	'<div class="quick-shop__info">'+
                                                '<div class="thumbnail-overlay">'+
                                                    '<div class="info text-align-center">'+
                                                        '{{itemProductInfo}}' +
                                                    '</div>'+
                                                '</div>' +
                                            '</div>';
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            if (!boostPFSConfig.custom.enable_quickshop){
                html = html.replace(/{{itemQuickShop}}/g, '');
            }
        }
        return html;
    }

    function buildPrice(data){
      const onSale = data.compare_at_price_max > data.price_min;
      const soldOut = !data.available;
      const priceVaries = data.price_max != data.price_min;
      if (soldOut) return `<span class="collection-item__price collection-item__price--sold-out">${boostPFSConfig.label.sold_out}</span>`

      return `
        <span class="collection-item__price">
          ${priceVaries ? `<small><em>${boostPFSConfig.label.from}</em></small>` : ''}
          <span class="${onSale ? 'sale' : ''}">${Utils.formatMoney(data.price_min) }</span>
          ${onSale ? `
            <s>
              <span class="visuallyhidden">was</span>
              ${Utils.formatMoney(data.compare_at_price_max)}
            </s>
          ` : ''}
        </span>
      `
    }

    function buildMessaging(data) {
      const matchingMessage = boostPFSConfig.messaging.find(message => message.tags.some(tag => data.tags.includes(tag)))
      if (!matchingMessage) return ''
      return `
        <p class="collection-item__message" style="--color: ${matchingMessage.color}">
          ${matchingMessage.message}
        </p>
      `
    }

    function bgset(image){
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      	if (!totalProduct) totalProduct = this.totalProduct

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

    // Build Sorting
    // ProductSorting.prototype.compileTemplate = function () {
    //     if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
    //         var sortingArr = Utils.getSortingList();
    //         if (sortingArr) {
    //             // Build content
    //             var sortingItemsHtml = '';
    //             for (var k in sortingArr) {
    //                 sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
    //             }
    //             var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    //             return html;
    //         }
    //     }
    //     return '';
    // };

   ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '<option selected disabled hidden>Sort By</option>';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());
		var $selectInput = jQ(Selector.topSorting + ' select');
		// if ($selectInput.length) {
  //           if (boostPFSConfig.general.default_sort_by != Globals.queryParams.sort) {
  //               $selectInput.val(Utils.stripHtml(Globals.queryParams.sort));
  //           }
			
		// }
	}

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
      document.dispatchEvent(new CustomEvent('boost:afterrender'))

      if (!data) data = this.data
      if (!eventType) eventType = this.eventType

      if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
          var count = 0;
          data.forEach(function(product) {
              var url = Utils.buildProductItemUrl(product, true);
              jQ.ajax({
                  type: "GET",
                  url: url + '?view=boost-pfs-quickview',
                  success: function (result) {
                        if (jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').length >= 1) {
                            let isColorBlasted;

                            if (jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').length > 1) {
                                isColorBlasted = true;
                            } else {
                                isColorBlasted = false;
                            }

                            jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').each(function () {
                                $(this).replaceWith(result);

                                if (isColorBlasted) {
                                    $('.js-quickshop-forms--' + product.id + ' .product_form').addClass('is_color_blasted');
                                }
                            });
                        }

                      count++;
                      if (count == data.length){
                          buildTheme();
                      }
                  }
              });
          })

        /*********************************************
        *       Init Mobile QuickView
        **********************************************/

          // On load grab mobile view buttons
          let mobileQuickViewBtn = document.querySelectorAll('.mobile-quickview-btn');

          mobileQuickViewBtn.forEach((btn) => {
            const productID = parseInt(btn.parentNode.parentNode.parentNode.dataset.id);
            const matchedProduct = data.find(item => parseInt(item.id) === productID);
            const matchedProductVariants = matchedProduct ? matchedProduct.variants : '';
            const sizeContainer = btn.parentNode.querySelector('.mobile-quickview-sizes');
            const hasSize = matchedProduct.options.includes('size');
            const firstVariant = matchedProduct.variants[0];
            const designatedColor = firstVariant.option_color;

            // Create variants within mobile quickview
            if(hasSize) {
              matchedProductVariants.forEach((variant) => {
                if(variant.option_color == designatedColor) {
                  const variantDiv = document.createElement('div');
                  if(variant.available) {
                    variantDiv.classList.add('quickview-variant-element');
                  } else {
                    variantDiv.classList.add('quickview-variant-element');
                    variantDiv.classList.add('oos');
                  }
                  variantDiv.setAttribute('data-id', variant.id);
                  variantDiv.textContent = variant.option_size;
                  sizeContainer.appendChild(variantDiv);
                }
              })
            } else {
              btn.textContent = "Add To Cart";
              btn.classList.add('atc-init');
              btn.classList.add('no-size');
              btn.setAttribute('data-product-selected', firstVariant.id)
              btn.setAttribute('data-single-product', '')
            }
          });

          // On button click show quickview
          $('.mobile-quickview-btn').on('click', function(event) {
            // Get the current button that was clicked
            let $currentBtn = $(event.currentTarget);

            // Find the specific .mobile-quickview-sizes container related to the clicked button
            let $sizeContainer = $currentBtn.parent().find('.mobile-quickview-sizes');

            // Check if the specific container already has the 'show' class
            let isShown = $sizeContainer.hasClass('show');

            // Remove 'show' class from all .mobile-quickview-sizes elements
            $('.mobile-quickview-sizes').removeClass('show');

            // If the specific container did not have the 'show' class, add it
            if (!isShown) {
              $sizeContainer.addClass('show');
            }
          });

        /*********************************************
         *  When User selects swatch variant
        **********************************************/

          let swatchBtns = document.querySelectorAll('.thumbnail-swatch .swatch');

          swatchBtns.forEach((btn) => {
            btn.addEventListener('click', (el) => {
              el.preventDefault();
              $('.mobile-quickview-sizes').removeClass('show');
              let currentBtn = el.currentTarget;
              let parentID = currentBtn.parentNode.parentNode.dataset.id;
              let swatchName = $(currentBtn).data('swatch-name');
              let colorName = swatchName.split('meta-color_')[1].replace('_', ' ').toLowerCase();
              let sizeContainer = currentBtn.closest('.product__thumbnail').querySelector('.mobile-quickview-sizes');
              sizeContainer.innerHTML = '';
              let targetUrl = currentBtn.getAttribute('href');
              currentBtn.closest('.product__thumbnail').querySelectorAll('.product-link').forEach((link) => {
                link.setAttribute('href', targetUrl);
              })
              currentBtn.closest('.product__thumbnail').querySelector('.thumbnail-swatch a:first-child').style.border = 'none';

              let matchedVariants = [];
              let variantTitles = new Set(); // To track unique variants by title
              data.forEach(item => {
                if(item.id == parentID) {
                  item.variants.forEach(variant => {
                    let variantOptions = variant.options.map(option => option.toLowerCase());
                  //   console.log('variant options: ', variantOptions)
                    if (variantOptions.includes(colorName) && !variantTitles.has(variant.title)) {
                      const matchedVariantImage = variant.image;
                      const targetImg = currentBtn.parentNode.parentNode.querySelector('.product-wrap .product-image__wrapper .product-link .image-element__wrap img');
                      // const targetLink
                      targetImg.setAttribute('data-srcset','');
                      targetImg.setAttribute('srcset','');
                      targetImg.setAttribute('src', matchedVariantImage);
                      matchedVariants.push(variant);
                      variantTitles.add(variant.title); // Mark this variant as added
                    }
                  });
                }
              });

              createNewSizes(matchedVariants, colorName, sizeContainer);
            });
          });

          function createNewSizes(matchedVariants, colorName, sizeContainer) {
            matchedVariants.forEach((variant) => {
              if (variant.option_color.toLowerCase() == colorName) {
                const variantDiv = document.createElement('div');
                if (variant.available) {
                  variantDiv.classList.add('quickview-variant-element');
                } else {
                  variantDiv.classList.add('quickview-variant-element');
                  variantDiv.classList.add('oos');
                }
                variantDiv.setAttribute('data-id', variant.id);
                variantDiv.textContent = variant.option_size;
                sizeContainer.appendChild(variantDiv);
              }
            });
          }

        /*********************************************
         *  When mobile quick view variant is clicked
        **********************************************/

          document.addEventListener('click', (event) => {
            const targetElement = event.target; // Get the actual element that was clicked
            if (targetElement.classList.contains('quickview-variant-element') && !targetElement.classList.contains('oos')) {
              const atcBtn = targetElement.parentNode.parentNode.querySelector('.mobile-quickview-btn')
              $('.quickview-variant-element').removeClass('active');
                targetElement.classList.toggle('active');
                let targetID = targetElement.dataset.id;
                atcBtn.setAttribute('data-product-selected', targetID);
                atcBtn.classList.add('atc-init');
                atcBtn.textContent = 'Add To Cart';
            }
          });

        /*********************************************
        *  Add Product from QuickView to cart
        **********************************************/

          $('.mobile-quickview-btn').on('click', (el) => {
            let singleProduct = false;
            let currentTarget = $(el.currentTarget);
            if($(currentTarget).data('single-product') !== undefined) {
              singleProduct = true;
            }

            if($(currentTarget).hasClass('atc-init')) {
              let productID = parseInt($('.quickview-variant-element.active').data('id'));

              if (isNaN(productID)) {
                productID = parseInt($(currentTarget).data('product-selected'));
              }

              let formData = {
                'items': [{
                'id': productID,
                'quantity': 1
                }]
              };

              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                contentType: 'application/json',  // Set the content type to JSON
                dataType: 'json',
                data: JSON.stringify(formData),  // Convert the formData object to a JSON string
                success: function(result) {
                  $(currentTarget).text('ADDED!');
                  // $(currentTarget).removeClass('atc-init');
                  $(currentTarget).addClass('atc-added');

                  setTimeout(function() {
                    if(singleProduct) {
                      $(currentTarget).text('Add To Cart');
                    } else {
                      $(currentTarget).text('QUICK SHOP');
                      $(currentTarget).removeClass('atc-init');
                      $(currentTarget).attr('data-product-selected', '');
                    }

                    $(currentTarget).removeClass('atc-added');
                    $('.quickview-variant-element').removeClass('active');
                  }, 1000);

                },
                error: function(obj, status) {
                  console.log('fail', obj, status);
                }
              });
            }
          });

      /*****************************************************************
      *         Closing the QuickView When user clicks out of MV
      *****************************************************************/

        $(document).on('click', function(event) {
            // Define the list of classes to check for
            var classList = ['mobile-quickview-btn', 'quickview-variant-element', 'mobile-quickview-sizes']; // Add your classes here
            var hasClass = false;
            // Check if the clicked element has any of the specified classes
            for (var i = 0; i < classList.length; i++) {
                if ($(event.target).hasClass(classList[i])) {
                    hasClass = true;
                    break;
                }
            }
            // If the clicked element does not have any of the specified classes
            if (!hasClass) {
                $('.mobile-quickview-sizes').removeClass('show');
            }

        });

      /*****************************************************************
      *                      END OF MV
      *****************************************************************/

      } else {
          buildTheme();
      }
      
      document.querySelectorAll(".boost-pfs-filter-products .product-image__wrapper").forEach(ProductEl => {
        ProductEl.addEventListener("mouseover", el => {
          const productSecondImg = el.currentTarget.querySelectorAll(".image-element__wrap");
          productSecondImg.length > 1 && (productSecondImg[0].classList.add("hide"),
          productSecondImg[1].classList.add("show"))
        });
        ProductEl.addEventListener("mouseleave", el => {
          const productSecondImg = el.currentTarget.querySelectorAll(".image-element__wrap");
          productSecondImg.length > 1 && (productSecondImg[0].classList.remove("hide"),
          productSecondImg[1].classList.remove("show"))
        });
      });
  };

    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {};

    function buildTheme(){
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }
        Shopify.PaymentButton.init();

        if (boostPFSConfig.custom.show_multiple_currencies) {
            convertCurrencies();
        }
    }

    /*** ticket: 204034 ***/
    FilterOptionItemSwatch.prototype.buildSwatchSettings = function() {
      var swatchSettings = boostPFSConfig.swatch_settings;
		var hasSwatchSetting = false;

		// Find case-insensitive swatch key
		this.swatchSettingKey = null;
		this.swatchSetting = null;
		if (swatchSettings) {
			var swatchKeys = Object.keys(swatchSettings);
			if (Array.isArray(swatchKeys) && swatchKeys.length > 0) {
				// Duplicate trimmable item
				swatchKeys.forEach(function(key) {
					if (key.toString().trim() !== key.toString()) {
						var _key = key.toString().trim();
						var swatch = swatchSettings[key];
						swatch['name'] = _key;
						swatchSettings[_key] = swatch;
						swatchKeys.push(_key)
					}
				});

				this.swatchSettingKey = swatchKeys.find(key =>
					key.replace('pfs-swatch-', '') == this.value ||
					key.replace('pfs-swatch-', '').toLowerCase() == this.value.toLowerCase());
				this.swatchSetting = swatchSettings[this.swatchSettingKey];
			}
		}

		if (swatchSettings && this.swatchSetting) {
			switch (this.swatchSetting.type) {
				case FilterOptionItemSwatch.SwatchType.ONE_COLOR:

					if (this.swatchSetting.colorCodes.length > 0 && this.swatchSetting.colorCodes[0]) {
						this.backgroundImage = 'none';
						this.backgroundColor = this.swatchSetting.colorCodes[0];
						hasSwatchSetting = true;
					}
					break;
				case FilterOptionItemSwatch.SwatchType.TWO_COLORS:
					if (this.swatchSetting.colorCodes.length > 1 && this.swatchSetting.colorCodes[0] && this.swatchSetting.colorCodes[1]) {
						this.backgroundImage = 'linear-gradient(to top left, ' + this.swatchSetting.colorCodes[1] + ' 50%, ' + this.swatchSetting.colorCodes[0] + ' 50%);';
						this.backgroundColor = 'transparent';
						hasSwatchSetting = true;
					}
					break;
				case FilterOptionItemSwatch.SwatchType.IMAGE:
					if (this.swatchSetting.imageUrl) {
						this.swatchFileUrl = this.swatchSetting.imageUrl;
						this.backgroundImage = 'url(' + this.swatchFileUrl + ');';
						this.backgroundColor = this.buildBackgroundColor(); // Fallback color for image
						hasSwatchSetting = true;
					}
					break;
			}
		}

		return hasSwatchSetting;
    }


        /* Boost-295118 */
        FilterOptionItem.prototype.buildLabel = function() {
            var filterOption = this.filterOption ? this.filterOption : this.parent;

            var label = Utils.unescape(this.label);
            var prefix = filterOption.prefix;

            if (typeof label != 'string') return '';

            // Remove Prefix
            if (typeof prefix == 'string') {
                prefix = prefix.replace(/\\/g, '');
                label = label.replace(prefix, '').trim();
            }

            // No capital label of Rating filter option
            if (label.indexOf('boost-pfs-filter-icon-star') > -1) return label;

            // Make the text to uppercase
            filterOption.displayAllValuesInUppercaseForm = filterOption.displayAllValuesInUppercaseForm || false;
            if (filterOption.displayAllValuesInUppercaseForm) return label.toUpperCase();

            // Make all letters lowercase first, then capitalize all first letters of each string in a filter option value
            // For example: HELLO World => Hello World
            if (Settings.getSettingValue('general.forceCapitalizeFilterOptionValues')) return Utils.capitalize(label, true);

            // Make all letters lowercase first, then capitalize first letter of a filter option value
            // For example: product fILTER => Product filter
            if (Settings.getSettingValue('general.capitalizeFirstLetterFilterOptionValues')) return Utils.capitalize(label, true, true);

            // Just capitalize first letter and don't change the format of any other letters
            // For example: hello wORLD => Hello WORLD
            if (Settings.getSettingValue('general.capitalizeFilterOptionValues')) return Utils.capitalize(label);

            // return label
            return Utils.stripHtml(label);
        };
        /* Boost-295118 */
})();

function _getWindowLocation() {
 // Escape window.location.href
 var href = window.location.href;
 var escapedHref = href.replace(/%3C/g, '&lt;').replace(/%3E/g, '&gt;');

 // Rebuild window.location.href
 var rebuildHrefArr = [];
 for (var i = 0; i < escapedHref.length; i++) {
  rebuildHrefArr.push(escapedHref.charAt(i));
 }
 var rebuildHref = rebuildHrefArr.join('').split('&lt;').join('%3C').split('&gt;').join('%3E');

 // Rebuild window.location.search
 var rebuildSearch = "";
 var hrefWithoutHash = rebuildHref.replace(/#.*$/, '');
 if (hrefWithoutHash.split('?').length > 1) {
  rebuildSearch = hrefWithoutHash.split('?')[1];
  if (rebuildSearch.length > 0) {
   rebuildSearch = '?' + rebuildSearch;
  }
 }

 return {
  pathname: window.location.pathname,
  href: rebuildHref,
  search: rebuildSearch
 }
}

function _isSearchPage() {
 // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/search?xxx
 // Google cache URL
 if (_getWindowLocation().href.includes('webcache.googleusercontent.com')) {
  return _getWindowLocation().search.indexOf('search?') > -1;

  // Normal URL
 } else {
  return window.location.pathname.indexOf('/search') > -1;
 }
};

function _isCollectionPage() {
 return window.location.pathname.includes('/collections');
};

FilterApi.beforeCall = function(eventType, eventInfo) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const sort = urlParams.get('sort')
  console.log(sort);

  if(boostPFSConfig.default_sort_order){
    if(_isSearchPage() && boostPFSConfig.default_sort_order.search && !sort){
      Globals.queryParams.sort = boostPFSConfig.default_sort_order.search
    }
    if(_isCollectionPage() && boostPFSConfig.default_sort_order.all && !sort){
      Globals.queryParams.sort = boostPFSConfig.default_sort_order.all
    }
  }

  if (Shopify && Globals) {
    Globals.queryParams.currency = Shopify.currency.active
    Globals.queryParams.currency_rate = Shopify.currency.rate
    Globals.queryParams.country = Shopify.country
  }
}

/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
